import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useIifImportSelector, IifImportActions, IifImportSelectors } from '../store/modules/iifImport';
import { useDispatch } from 'react-redux';
import { Paper, makeStyles, Typography, LinearProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { RequestState } from '../store/modules';
import IifFileView from '../components/IifFileView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/pro-duotone-svg-icons/faFileInvoiceDollar';
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt';
import { useApplicationSettingsSelector, TaxMode, ApplicationSettingsActions, ApplicationSettingsSelectors } from '../store/modules/applicationSettings';

import { debounce } from 'lodash';

export interface IUploadPageProps {

}

const useStyles = makeStyles(theme => ({
    title: {
        margin: theme.spacing(3, 0, 3, 0)
    },
    paper: {
        padding: theme.spacing(3)
    },
    dropzone: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',

        '& + div': {
            display: 'none'
        }
    },
    chips: {
        width: '100%',
        borderRadius: 0,
        marginTop: -3,
        display: 'flex',
        justifyContent: 'space-between',
        background: '#F0F0F0',
        border: '3px dashed #C8C8C8',
        height: 'auto',

        '& :first-child':
        {
            marginTop: 12,
            marginBottom: 12
        },

        '& span': {
            fontSize: '1rem'
        },

        '& :last-child':
        {
            marginLeft: 'auto'
        }
    }
}))

const ACCEPTED_FILES = [''];

const DEBOUNCE_INTERVAL = 250;

const UploadPage: React.FunctionComponent<IUploadPageProps> = ({

}) => {
    const fileView = useIifImportSelector(IifImportSelectors.selectView);
    const loadState = useIifImportSelector(IifImportSelectors.selectLoadState);

    const taxMode = useApplicationSettingsSelector(ApplicationSettingsSelectors.selectTaxMode);

    const dispatch = useDispatch();

    const onChange = React.useCallback(debounce((files: FileList) => {

        if (!files) {
            dispatch(IifImportActions.clear());

            return;
        }

        dispatch(IifImportActions.processFiles(files))

    }, DEBOUNCE_INTERVAL), [dispatch]);

    const onTaxChange = React.useCallback((event: React.ChangeEvent<{ value: TaxMode }>) => {
        dispatch(ApplicationSettingsActions.setTaxMode(event.target.value));
    }, [dispatch]);

    const classes = useStyles();

    return (
        <>
            <Typography variant="h1" className={classes.title}>
                Import - IIF Files
            </Typography>
            <Select
                value={taxMode}
                onChange={onTaxChange}
            >
                <MenuItem value={TaxMode.Included}>Tax Included</MenuItem>
                <MenuItem value={TaxMode.Excluded}>Tax Excluded</MenuItem>
            </Select>
            <Paper className={classes.paper} >
                <DropzoneArea
                    filesLimit={5000}
                    dropzoneClass={classes.dropzone}
                    onChange={onChange}
                    acceptedFiles={ACCEPTED_FILES}
                    dropzoneText="Drag and drop IIF files here or click"
                    useChipsForPreview={true}
                    showPreviewsInDropzone={false}
                    showPreviews={true}
                    showAlerts={false}
                    previewChipProps={{
                        className: classes.chips,
                        icon: <FontAwesomeIcon icon={faFileInvoiceDollar} fixedWidth size="2x" />,
                        deleteIcon: <FontAwesomeIcon icon={faTrashAlt} fixedWidth size="2x" />
                    }}
                />
                {
                    loadState.state === RequestState.Pending ?
                        <LinearProgress color="secondary" /> :
                        null
                }
            </Paper>
            {
                fileView?.map(fileIndex => {
                    return (
                        <IifFileView
                            key={fileIndex}
                            fileIndex={fileIndex}
                        />
                    );
                })
            }
        </>
    )
}

export default UploadPage;



// WEBPACK FOOTER //
// ./src/pages/UploadPage.tsx